import { moment } from "ngx-bootstrap/chronos/test/chain";
import { EntityQuery } from "./entity.query.model";

export class CampaignThemeCategoryListItemDto {
    public id: number;
    public campaignThemeId: number;
    public themeCategoryId: number;
    public themeCategoryName: string;
    public createdDate: Date;
    public createdBy: number;
    public markedForDeletion: boolean;
}

export class CampaignThemeTacticListItemDto {
    public id: number;
    public campaignThemeId: number;
    public userId: number;
    public tacticId: number;
    public tacticTacticName: string;
    public tacticTacticDesc: string;
    public tacticDocumentId: number;
    public tacticTacticProductionOptionId: number;
    public tacticFlatCost: number;
    public tacticMinimumQuantity: number;
    public tacticMaximumQuantity: number;
    public createdDate: Date;
    public createdBy: number;
    public timesAdded: number;
    public inventoryImportTotal: number;
    public hasInventory: boolean;
    public tacticProductTypeId: number;
    public lockAddButton: boolean;
}

export class CampaignThemeKeywordListItemDto {
    public id: number;
    public campaignThemeId: number;
    public searchKey: string;
    public createdDate: Date;
    public createdBy: number;
    public markedForDeletion: boolean;
}

export class CampaignThemeBrandListItemDto {
    public id: number;
    public campaignThemeId: number;
    public brandId: number;
    public brandName: string;
    public CreatedDate: Date;
    public CreatedBy: number;
    public markedForDeletion: boolean;
}

export class CampaignThemeListItemDto {
    public id: number;
    public name: string;
    public isActive: boolean;
    public createdDate: Date;
    public createdBy: number;
    public themeInfoId: number;
    public shortDescription: string;
    public longDescription: string;
    public campaignThemeCategory: CampaignThemeCategoryListItemDto[];
    public themeCategoryCount: number;
}

export class CampaignThemeCategoryLookupItemDto {
    public id: number;
    public name: string;
    public createdDate: Date;
    public createdBy: number;
}

export class CreateThemeCategoryCommand
{
    public name: string;
}

export class SaveCampaignThemeCommand
{
    campaignTheme: CampaignThemeDto;
    userRoles: Array<{id, name}>;
    customizations: Array<{id, name}>;
    showToAllRoles: boolean;
    showAsRecomended: boolean;

    public set(dto: CampaignThemeDto) {
        this.campaignTheme = dto;
        this.campaignTheme.startDate = dto.startDateFormatted === "" ? null : new Date(dto.startDateFormatted);
        this.campaignTheme.endDate = dto.endDateFormatted === "" ? null : new Date(dto.endDateFormatted);
    }
}

export class CampaignThemeId {
    constructor(public id: number) {

    }
}

export class CampaignThemeDto {
    public id: number;
    public name: string;
    public isActive: boolean;
    public createdDate: Date;
    public createdBy: number;
    public shortDescription: string;
    public longDescription: string;
    public startDate: Date;
    public endDate: Date;

    public startDateFormatted: string;
    public endDateFormatted: string;

    public campaignThemeCategory: CampaignThemeCategoryListItemDto[];
    public campaignThemeKeyword: CampaignThemeKeywordListItemDto[];
    public campaignThemeBrand: CampaignThemeBrandListItemDto[];
    public documentId: number;
    public documentFileName: string;
    public userRoles = new Array<{id: number, name: string}>();
    public showToAllRoles: boolean;
    public showToSpecificRoles: boolean;
    public showAsRecomended: boolean;
    public campaignThemeTypeID: number;
    public campaignThemeTypeName: string;

    constructor() {
        this.campaignThemeBrand = new Array<CampaignThemeBrandListItemDto>();
        this.campaignThemeCategory = new Array<CampaignThemeCategoryListItemDto>();
        this.campaignThemeKeyword = new Array<CampaignThemeKeywordListItemDto>();
    }

    public static fixDates(obj: CampaignThemeDto): CampaignThemeDto {
        obj.startDate = obj.startDate == null ? null : moment(obj.startDate).toDate();
        obj.endDate = obj.endDate == null ? null : moment(obj.endDate).toDate();
        return obj;
    }
}

export class CampaignThemeSearch extends EntityQuery {
    public themeCategoryContains: string;
    public nameContains: string;
    public brandContains: string;
    public keywordContains: string;
    public themeCategoryId: number;
    public id: number;
}

export class MyCampaignSearch extends EntityQuery {
    public id: number;
    public nameContains: string;
    public retailContains: string;
    public startDateContains: string;
    public endDateContains: string;
    public statusContains: string;
    public deliveryStatusContains: string;
    public createdByContains: string;
    public onlyMyCampaigns: boolean;
}



// WEBPACK FOOTER //
// ./src/app/client-core/dtos/campaigns.model.ts